import React from 'react';

import MuiTooltip from '@material-ui/core/Tooltip';

function Tooltip(props) {

  return (
    <MuiTooltip {...props} />
  );
}

Tooltip.propTypes = {
  ...MuiTooltip.propTypes,
};

Tooltip.defaultProps = {
  ...MuiTooltip.defaultProps,
  placement: 'top',
};

export default Tooltip;
